import { getInProgressCampaigns as getInProgressCampaignsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetInProgressCampaignsServiceResponse } from './get-in-progress-campaigns.dto';
import { GetInProgressCampaignsServiceResponseSchema } from './get-in-progress-campaigns.dto';

export const getInProgressCampaignsService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetInProgressCampaignsServiceResponse> => {
    const apiResponse = await getInProgressCampaignsApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '진행중인 캠페인 조회에 실패했습니다.');
    }

    return {
      campaigns: apiResponse.data.campaigns,
      totalCount: apiResponse.data.totalCount,
    };
  }, validateServiceResponse(GetInProgressCampaignsServiceResponseSchema)),
);
